import { DefaultAgentIcon } from 'ai-components-ui-library/components/icons/internal/DefaultAgentIcon';
import { getAppInfo } from 'chatspot-core/utils/appUtils';
import { DocumentsIcon } from 'foundations-assets/icons/components/DocumentsIcon';
import { FileIcon } from 'foundations-assets/icons/components/FileIcon';
import { PdfFileIcon } from 'foundations-assets/icons/components/PdfFileIcon';
import { Flex } from 'foundations-components/components/Flex';
import { Image } from 'foundations-components/transitional/components/Image';
import Raven from 'raven-js';
import { useContext } from 'react';
import { HUBSPOT_WEB_CITATION_ICON_MAP } from '../../constants/icons';
import { SectionContext } from '../../context/SectionContext';
import { getCrmCitationObjectNameAndIcon } from '../../utils/citationUtils';
import { sanitizeImageSrc } from '../../utils/imageSrcSanitizer';
import CrmCitationIcon from '../text/MarkdownWithCitations/CrmCitationIcon';
import { gate } from 'hub-http/gates';
import { jsx as _jsx } from "react/jsx-runtime";
export const StyledIconHolderWrapper = ({
  Icon
}) => /*#__PURE__*/_jsx(Flex, {
  backgroundColor: "icon-core-default",
  borderRadius: "full",
  blockSize: "20px",
  inlineSize: "20px",
  padding: "100",
  alignItems: "center",
  justifyContent: "center",
  children: /*#__PURE__*/_jsx(Icon, {
    color: "icon-core-on-fill-default"
  })
});
export const CitationsIcon = ({
  iconSrc,
  sourceType,
  data
}) => {
  const {
    getIsUngated,
    allowedImageHosts
  } = useContext(SectionContext);
  const isUngatedForLocationWithinSource = getIsUngated(gate('KnowledgeBox:LocationWithinSource'));
  if (iconSrc) {
    const sanitizedSrc = sanitizeImageSrc(iconSrc, {
      trustedHosts: allowedImageHosts
    });
    if (!sanitizedSrc) {
      Raven.captureMessage('CitationsIcon: Invalid image src', {
        extra: {
          src: iconSrc
        }
      });
      return null;
    }
    return /*#__PURE__*/_jsx(Image, {
      src: iconSrc,
      alt: iconSrc,
      width: 18,
      height: 18,
      shape: "rounded"
    });
  }
  if (sourceType === 'CRM_OBJECT' && 'objectTypeId' in data) {
    const {
      icon: IconToUse
    } = getCrmCitationObjectNameAndIcon({
      objectTypeId: data.objectTypeId
    });
    return /*#__PURE__*/_jsx(CrmCitationIcon, {
      size: isUngatedForLocationWithinSource ? '400' : '50',
      padding: isUngatedForLocationWithinSource ? '100' : '50',
      defaultIcon: IconToUse,
      objectTypeId: data.objectTypeId,
      objectId: data.objectId
    });
  }
  if (sourceType === 'APP') {
    const appSourceData = data;
    const appInfo = getAppInfo(appSourceData.appName, appSourceData.url);
    return /*#__PURE__*/_jsx(Image, {
      src: appInfo.iconUrl,
      alt: appInfo.displayName,
      width: 18,
      height: 18,
      shape: "rounded"
    });
  }
  if (sourceType === 'WEBSITE' && 'domain' in data) {
    if ('url' in data && (data.domain === 'hubspot.com' || data.domain.endsWith('.hubspot.com') || data.domain === 'hubspotqa.com' || data.domain.endsWith('.hubspotqa.com'))) {
      const matchedIcon = HUBSPOT_WEB_CITATION_ICON_MAP.find(({
        slug
      }) => {
        try {
          const url = new URL(data.url);
          return url.pathname.startsWith(`/${slug}/`);
        } catch (_unused) {
          return data.url.includes(`/${slug}/`);
        }
      });
      if (matchedIcon) {
        return /*#__PURE__*/_jsx(StyledIconHolderWrapper, {
          Icon: matchedIcon.icon
        });
      }
    }
    return /*#__PURE__*/_jsx(Image, {
      src: `https://www.google.com/s2/favicons?sz=24&domain=${data === null || data === void 0 ? void 0 : data.domain}`,
      alt: data === null || data === void 0 ? void 0 : data.domain,
      width: 18,
      height: 18,
      shape: "rounded"
    });
  }
  if (sourceType === 'AI_SKILL') {
    return /*#__PURE__*/_jsx(DefaultAgentIcon, {
      marginBlockEnd: "0",
      size: 18,
      rounded: true
    });
  }
  if (sourceType === 'FILE_UPLOAD' && 'fileType' in data) {
    switch (data === null || data === void 0 ? void 0 : data.fileType) {
      case 'pdf':
        return /*#__PURE__*/_jsx(StyledIconHolderWrapper, {
          Icon: PdfFileIcon
        });
      default:
        return /*#__PURE__*/_jsx(StyledIconHolderWrapper, {
          Icon: FileIcon
        });
    }
  }
  return /*#__PURE__*/_jsx(StyledIconHolderWrapper, {
    Icon: DocumentsIcon
  });
};